module.exports = __webpack_public_path__ + "img/connectpage.6e2a8988.gif";